export const GET_CURRENCY_CONVERSION = "GET_CURRENCY_CONVERSION";
export const GET_CURRENCY_CONVERSION_SUCCESS =
  "GET_CURRENCY_CONVERSION_SUCCESS";
export const GET_CURRENCY_CONVERSION_ERROR = "GET_CURRENCY_CONVERSION_ERROR";

export const PUT_CURRENCY_CONVERSION = "PUT_CURRENCY_CONVERSION";
export const PUT_CURRENCY_CONVERSION_SUCCESS =
  "PUT_CURRENCY_CONVERSION_SUCCESS";
export const PUT_CURRENCY_CONVERSION_ERROR = "PUT_CURRENCY_CONVERSION_ERROR";
